import React, { useState, useEffect } from 'react';
import {
    Container, Box, Typography,  Paper, Button, Divider, IconButton,
    Checkbox,
} from '@mui/material';
import { createbooking, getUserCart, increamentCart, decreamentCart, DeleteCart, updateuserAdderss, getuserAddress, deleteUserAddress, getAllDeliveryPrices } from '../services/Apis';
import { useFilter } from '../context/FilterContext';
import emptycartpage from "../assets/cartemptybg.webp";
import { createUserAddress } from '../services/Apis';
import FeildModel from '../Popup\'s/FeildModel';
import useResponsive from '../hooks/useResponsive';
import axios from 'axios';
import apiUrl from '../Config';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';

const fields = [
    { label: "Full Name", name: "fullName" },
    { label: "S/o,D/o,W/o", name: "parentName" },
    { label: "House / Flat No", name: "houseNo" },
    { label: "Street", name: "street" },
    { label: "Village", name: "village" },
    { label: "Mandal", name: "mandal" },
    { label: "Land Mark", name: "landmark" },
    { label: "City", name: "city" },
    { label: "District", name: "district" },
    { label: "State", name: "state" },
    { label: "Country", name: "country" },
    { label: "PIN Code", name: "pincode" },
    { label: "Mobile Number", name: "phoneNumber" },
];


const Checkout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const fromCart = location.state?.fromCart;
    const book = !fromCart ? location.state : null; // Only set book if not from cart

    const [deliveryPrice, setDeliveryPrice] = useState(location.state?.deliveryPrice ?? 0);
    const [loading, setLoading] = useState(false);

    const { token } = useFilter();
    const { isSmallScreen } = useResponsive()
    const [showMore, setShowMore] = useState(false);
    const [products, setProducts] = useState([]);
    const [, setCartItems] = useState([]);
    const [addressSaved, setAddressSaved] = useState(false);
    const [addressForm, setAddressForm] = useState({
        fullName: "",
        parentName: "",
        houseNo: "",
        street: "",
        village: "",
        mandal: "",
        district: "",
        city: "",
        state: "",
        country: "India",
        pincode: "",
        phoneNumber: ""
    });
    const VISIBLE_COUNT = 2;
    const [addressError, setAddressError] = useState("");
    const [addressSuccess, setAddressSuccess] = useState("");
    const [openAddressModal, setOpenAddressModal] = useState(false);
    const [addresses, setAddresses] = useState([]);
    const [selectedAddressId, setSelectedAddressId] = useState(() => {
        // Load selected address ID from localStorage if available
        if (typeof window !== 'undefined') {
            const savedAddressId = localStorage.getItem('selectedAddressId');
            return savedAddressId ? JSON.parse(savedAddressId) : null;
        }
        return null;
    });
    const [editingAddressId, setEditingAddressId] = useState(null);
    const [termsAccepted, setTermsAccepted] = useState(false);

    useEffect(() => {
        const fetchCart = async () => {
            const cart = await getUserCart(token);
            setCartItems(cart?.cartItems || []);
            const mappedProducts = (cart?.cartItems || []).map(item => ({
                id: item.bookId || item.comboId,
                cartItemId: item.id,
                name: item.title,
                price: Number(item.discountedPrice) || Number(item.originalPrice) || 0,
                quantity: item.quantity,
                image:
                    typeof item.imageUrl === 'object' && item.imageUrl !== null
                        ? item.imageUrl.imageUrl
                        : item.imageUrl || emptycartpage,
                hidden: false,
                subtotal: item.subtotal,
            }));
            setProducts(mappedProducts);
        };

        const fetchDeliveryPrice = async () => {
            const prices = await getAllDeliveryPrices();
            const active = prices.find(p => p.isActive);
            setDeliveryPrice(active ? active.amount : 0);
        };

        if (book) {
            // If book is present, use its details directly
            const originalPrice = Number(book.price) || 0;
            const discountOffer = Number(book.discountOffer) || 0;
            const discountedPrice = discountOffer
                ? +(originalPrice - (originalPrice * discountOffer / 100)).toFixed(2)
                : originalPrice;

            setProducts([{
                id: book.id,
                cartItemId: book.id,
                name: book.title,
                price: Number(book.discountedPrice) || discountedPrice || 0,
                discountOffer: book.discountOffer || "",
                quantity: 1,
                image: (book.bookImages && book.bookImages.length > 0 && book.bookImages[0].imageUrl)
                    ? book.bookImages[0].imageUrl
                    : book.imageUrl || emptycartpage, // fallback to emptycartpage
                hidden: false,
                subtotal: Number(book.discountedPrice) || Number(book.price) || 0,
            }]);
            fetchDeliveryPrice(); // <-- fetch delivery price for Buy Now
        } else {
            // Otherwise, use cart
            fetchCart();
            // deliveryPrice is already set from location.state for cart
        }
    }, [token, book]);

    useEffect(() => {
        const fetchUserAddress = async () => {
            try {
                const res = await getuserAddress(token);
                if (res && Array.isArray(res.addresses) && res.addresses.length > 0) {
                    const validAddresses = res.addresses.filter(addr => !addr.isDeleted);
                    setAddresses(validAddresses);
                    setAddressSaved(true);
                    
                    // Only update selectedAddressId if it's not set or the current selection is no longer valid
                    const currentAddressExists = validAddresses.some(addr => addr.id === selectedAddressId);
                    if (!currentAddressExists && validAddresses.length > 0) {
                        const newSelectedId = validAddresses[0].id;
                        setSelectedAddressId(newSelectedId);
                        localStorage.setItem('selectedAddressId', JSON.stringify(newSelectedId));
                    }
                    
                    // Update form with the first address if no address is selected
                    if (!selectedAddressId && validAddresses.length > 0) {
                        const [first] = validAddresses;
                        const openEditModal = (address) => {
                            setAddressForm({
                                fullName: address.name || "",
                                parentName: address.parentName || "",
                                houseNo: address.houseNo || "",
                                street: address.street || "",
                                village: address.village || "",
                                mandal: address.mandal || "",
                                district: address.district || "",
                                city: address.city || "",
                                state: address.state || "",
                                country: address.country || "India",
                                pincode: address.pincode || "",
                                phoneNumber: address.phoneNumber || "",
                            });
                            setEditingAddressId(address.id);
                            setOpenAddressModal(true);
                        };
                        openEditModal(first);
                    }
                } else {
                    setAddresses([]);
                    setSelectedAddressId(null);
                    localStorage.removeItem('selectedAddressId');
                }
            } catch (err) {
                console.error(err);
                setAddresses([]);
                setSelectedAddressId(null);
                localStorage.removeItem('selectedAddressId');
            }
        };
        if (token) fetchUserAddress();
    }, [token, selectedAddressId]);

    const handleIncrement = async (cartItemId, currentQuantity) => {
        await increamentCart(cartItemId, { quantity: currentQuantity + 1 });
        const cart = await getUserCart(token);
        setCartItems(cart?.cartItems || []);
        setProducts((cart?.cartItems || []).map(item => ({
            id: item.bookId || item.comboId,
            cartItemId: item.id,
            name: item.title,
            price: Number(item.discountedPrice) || Number(item.originalPrice) || 0,
            quantity: item.quantity,
            image:
                typeof item.imageUrl === 'object' && item.imageUrl !== null
                    ? item.imageUrl.imageUrl
                    : item.imageUrl || emptycartpage,
            hidden: false,
            subtotal: item.subtotal,
        })));
    };

    const handleDecrement = async (cartItemId, currentQuantity) => {
        if (currentQuantity <= 1) return;
        await decreamentCart(cartItemId, { quantity: currentQuantity - 1 });
        const cart = await getUserCart(token);
        setCartItems(cart?.cartItems || []);
        setProducts((cart?.cartItems || []).map(item => ({
            id: item.bookId || item.comboId,
            cartItemId: item.id,
            name: item.title,
            price: Number(item.discountedPrice) || Number(item.originalPrice) || 0,
            quantity: item.quantity,
            image:
                typeof item.imageUrl === 'object' && item.imageUrl !== null
                    ? item.imageUrl.imageUrl
                    : item.imageUrl || emptycartpage,
            hidden: false,
            subtotal: item.subtotal,
        })));
    };

    const handleDeleteAddress = async (id) => {
        try {
            await deleteUserAddress(id, token);
            const res = await getuserAddress(token);
            const validAddresses = (res.addresses || []).filter(addr => !addr.isDeleted);
            setAddresses(validAddresses);
            
            // If the deleted address was selected, select the first available address
            if (selectedAddressId === id) {
                if (validAddresses.length > 0) {
                    const newSelectedId = validAddresses[0].id;
                    setSelectedAddressId(newSelectedId);
                    localStorage.setItem('selectedAddressId', JSON.stringify(newSelectedId));
                } else {
                    setSelectedAddressId(null);
                    localStorage.removeItem('selectedAddressId');
                }
            }
        } catch (error) {
            console.error('Error deleting address:', error);
            // Handle error appropriately
        }
    };

    const handleDelete = async (cartItemId, bookId, quantity) => {
        const userId = 1;
        await DeleteCart(cartItemId, { userId, bookId, quantity });
        const cart = await getUserCart(token);
        setCartItems(cart?.cartItems || []);
        setProducts((cart?.cartItems || []).map(item => ({
            id: item.bookId || item.comboId,
            cartItemId: item.id,
            name: item.title,
            price: Number(item.discountedPrice) || Number(item.originalPrice) || 0,
            quantity: item.quantity,
            image:
                typeof item.imageUrl === 'object' && item.imageUrl !== null
                    ? item.imageUrl.imageUrl
                    : item.imageUrl || emptycartpage,
            hidden: false,
            subtotal: item.subtotal,
        })));
    };

    const handleAddressChange = (e) => {
        const { name, value } = e.target;
        if (name === "phoneNumber") {
            // Allow only numbers and max 10 digits
            if (/^\d{0,10}$/.test(value)) {
                setAddressForm({ ...addressForm, [name]: value });
            }
        } else if (name === "pincode") {
            // Allow only numbers and max 6 digits (optional, adjust as needed)
            if (/^\d{0,6}$/.test(value)) {
                setAddressForm({ ...addressForm, [name]: value });
            }
        } else {
            setAddressForm({ ...addressForm, [name]: value });
        }
    };

    const handleAddressSubmit = async (e) => {
        e.preventDefault();
        setAddressError("");
        setAddressSuccess("");

        // Basic validation
        if (!addressForm.fullName || !addressForm.houseNo || !addressForm.street || !addressForm.city || !addressForm.state || !addressForm.pincode || !addressForm.phoneNumber) {
            setAddressError("Please fill in all required fields.");
            return;
        }

        if (!/^\d{6}$/.test(addressForm.pincode)) {
            setAddressError("Please enter a valid 6-digit PIN code.");
            return;
        }

        if (!/^\d{10}$/.test(addressForm.phoneNumber)) {
            setAddressError("Please enter a valid 10-digit phone number.");
            return;
        }

        const payload = {
            name: addressForm.fullName.trim(),
            phoneNumber: addressForm.phoneNumber,
            parentName: addressForm.parentName.trim(),
            houseNo: addressForm.houseNo,
            villageOrTown: addressForm.village.trim(),
            landmark: addressForm.landmark.trim(),
            mandal: addressForm.mandal.trim(),
            district: addressForm.district.trim(),
            street: addressForm.street.trim(),
            city: addressForm.city.trim(),
            country: addressForm.country.trim(),
            state: addressForm.state.trim(),
            pincode: addressForm.pincode
        };

        try {
            if (editingAddressId) {
                await updateuserAdderss(editingAddressId, payload, token);
            } else {
                await createUserAddress(payload, token);
            }

            setAddressSuccess("Address saved successfully!");
            setAddressSaved(true);
            setOpenAddressModal(false);
            setEditingAddressId(null);

            // Refresh addresses
            const res = await getuserAddress(token);
            const updatedAddresses = (res.addresses || []).filter(addr => !addr.isDeleted);
            setAddresses(updatedAddresses);

            // Set the newly added/updated address as selected
            let newSelectedId = editingAddressId;
            if (!newSelectedId && updatedAddresses.length > 0) {
                newSelectedId = updatedAddresses[0].id;
                setSelectedAddressId(newSelectedId);
                localStorage.setItem('selectedAddressId', JSON.stringify(newSelectedId));
            }
        } catch (err) {
            setAddressError(err.response?.data?.message || "Failed to save address.");
            console.error("Error saving address:", err);
        }
    };

    const handlePlaceOrder = async () => {
        try {
            // Better address validation
            const selectedAddress = addresses.find(addr => addr.id === selectedAddressId);

            if (!selectedAddress) {
                toast.error("Please select a delivery address");
                return;
            }

            const bookOrCombo = location.state;

            let booking;
            if (fromCart) {
                booking = await createbooking({
                    addressId: selectedAddress.id,
                    token,
                    type: 'cart'
                });
            } else if (bookOrCombo) {
                if (bookOrCombo.isCombo) {
                    booking = await createbooking({
                        addressId: selectedAddress.id,
                        token,
                        type: 'buynow',
                        comboId: bookOrCombo.id,
                        quantity: 1
                    });
                } else {
                    booking = await createbooking({
                        addressId: selectedAddress.id,
                        token,
                        type: 'buynow',
                        bookId: bookOrCombo.id,
                        quantity: 1
                    });
                }
            } else {
                console.log("No valid order data found");
                toast.error("No items to order");
                return;
            }

            if (booking?.status === true) {
                checkoutHandler(booking.bookingId, booking.totalAmount ?? totalAmount);
            } else {
                const errorMsg = booking?.message || "Failed to place order";
                console.error("Order failed:", errorMsg);
                toast.error(errorMsg);
            }
        } catch (err) {
            console.error("Order error:", err);
            toast.error(err.response?.data?.message || "Failed to place order. Please try again.");
        }
    };

    const checkoutHandler = async (bookingId, amount) => {
        try {
            // Step 1: Hit your backend to create Razorpay order
            const response = await axios.post(`${apiUrl}/payments/checkout`, {
                amount
            });

            if (response.data.status) {
                const { orderId, amount: orderAmount, currency } = response.data;

                const fetchCart = async () => {
                    try {
                        const cart = await getUserCart(token);
                        setCartItems(cart?.cartItems || []);
                        const mappedProducts = (cart?.cartItems || []).map(item => ({
                            id: item.bookId || item.comboId,
                            cartItemId: item.id,
                            name: item.title,
                            price: Number(item.discountedPrice) || Number(item.originalPrice) || 0,
                            quantity: item.quantity,
                            image: typeof item.imageUrl === 'object' && item.imageUrl !== null
                                ? item.imageUrl.imageUrl
                                : item.imageUrl || emptycartpage,
                            hidden: false,
                            subtotal: item.subtotal,
                        }));
                        setProducts(mappedProducts);
                    } catch (error) {
                        console.error('Error fetching cart:', error);
                        toast.error('Failed to refresh cart');
                    }
                };

                const options = {
                    key: 'rzp_test_FsZ4MzmUoVU8Cv',
                    amount: orderAmount,
                    currency,
                    name: 'Indian Book House',
                    order_id: orderId,
                    handler: async function (paymentResponse) {
                        try {
                            setLoading(true);
                            await axios.post(`${apiUrl}/payments/paymentverification`, {
                                bookingId,
                                paymentResponse
                            });
                            // Clear cart on successful payment if coming from cart
                            if (fromCart) {
                                setProducts([]);
                                setCartItems([]);
                            }
                            navigate('/my-profile/orders');
                        } catch (err) {
                            console.error('Payment verification failed:', err);
                            toast.error('Payment verification failed. Please check your orders.');
                        } finally {
                            setLoading(false);
                        }
                    },
                    prefill: {
                        name: 'Vishal Vicky',
                        email: 'vishal@example.com',
                        contact: '9999999999',
                    },
                    notes: {
                        address: 'Abilio Office',
                    },
                    theme: {
                        color: '#3399cc',
                    },
                    modal: {
                        ondismiss: async function() {
                            // This runs when the payment modal is closed without completing payment
                            try {
                                if (fromCart) {
                                    await fetchCart();
                                    toast.info('Payment was cancelled. Your cart has been restored.');
                                }
                            } catch (error) {
                                console.error('Error handling payment cancellation:', error);
                                toast.error('Failed to restore cart. Please refresh the page.');
                            }
                        }
                    }
                };

                const razorpay = new window.Razorpay(options);
                razorpay.open();
            }
        } catch (error) {
            console.error('Payment initiation failed:', error);
            toast.error('Failed to initiate payment. Please try again.');
        }
    };

    const totalAmount = products.length > 0
        ? products.reduce((sum, item) => sum + (Number(item.price) || 0) * (item.quantity || 1), 0)
        : 0;

    const grandTotal = totalAmount + deliveryPrice;
    if (products.length === 0) {
        return (
            <Container maxWidth="xl" sx={{ py: 4, minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    width="100%"
                    textAlign="center"
                >
                    <Box
                        component="img"
                        src={emptycartpage}
                        alt="Empty Cart"
                        sx={{
                            width: { xs: 350, sm: 290, md: 360, lg: 380 },
                            mb: 2
                        }}
                    />
                    <Typography variant="h3" fontWeight="600" gutterBottom>
                        Sorry no products in Cart!
                    </Typography>
                    <Typography variant="h5" gutterBottom mb={2}>
                        You have not added any products to your Cart.
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={() => navigate('/')}
                        sx={{
                            mt: 2,
                            backgroundColor: '#CB4422',
                            textTransform: 'none',
                            mb: { xs: 4, md: 4 }
                        }}
                    >
                        Shop Now
                    </Button>
                </Box>
            </Container>
        );
    }

    const openAddModal = () => {
        setAddressForm({
            fullName: "",
            parentName: "",
            houseNo: "",
            street: "",
            village: "",
            mandal: "",
            district: "",
            city: "",
            state: "",
            country: "India",
            pincode: "",
            phoneNumber: ""
        });
        setEditingAddressId(null);
        setOpenAddressModal(true);
    };

    return (
        <Container maxWidth="xl" sx={{ py: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
                <Typography variant="h4" fontWeight={600} sx={{ fontFamily: 'Poppins' }}>
                    Checkout details
                </Typography>
            </Box>
            <Box sx={{
                display: 'flex', flexDirection: { xs: 'column', md: 'row' },
                gap: 4, alignItems: 'flex-start',
            }}>
                {/* Left: Address */}
                <Box sx={{ flex: 2 }}>
                    {!addressSaved ? (
                        <Button
                            disableFocusRipple
                            disableRipple
                            variant="contained"
                            onClick={openAddModal}
                            sx={{
                                background: '#CB4422',
                                color: '#fff',
                                fontFamily: 'Poppins',
                                fontWeight: 600,
                                fontSize: 16,
                                borderRadius: 2,
                                py: 1.2,
                                boxShadow: 'none',
                            }}
                        >
                            + Add Address
                        </Button>
                    ) : (
                        <Box sx={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                            {/* Add/Edit/Delete Icons */}
                            <Paper >

                                <Box sx={{ position: 'absolute', top: isSmallScreen ? -55 : -55, right: 0, zIndex: 3, display: 'flex', gap: 1 }}>
                                    <IconButton size="small"
                                        onClick={openAddModal}
                                        sx={{
                                            backgroundColor: '#CB4422', color: '#FFFFFF',
                                            border: 'none', borderRadius: '5px', padding: '5px 10px',
                                            fontSize: '14px', fontFamily: "Poppins", cursor: 'pointer'
                                        }}
                                    >
                                        <i className="fas fa-plus" style={{ color: '#FFFFFF' }} />
                                        <span style={{ marginLeft: '5px' }}>Add Address</span>
                                    </IconButton>

                                </Box>
                            </Paper>
                        </Box>
                    )}
                    {addressSaved && addresses.length > 0 && addresses.map((addr, idx) => {
                        return (
                            <Paper
                                key={addr.id}
                                onClick={() => {
                                    const openEditModal = (address) => {
                                        setAddressForm({
                                            fullName: address.name || "",
                                            parentName: address.parentName || "",
                                            houseNo: address.houseNo || "",
                                            street: address.street || "",
                                            village: address.village || "",
                                            mandal: address.mandal || "",
                                            district: address.district || "",
                                            city: address.city || "",
                                            state: address.state || "",
                                            country: address.country || "India",
                                            pincode: address.pincode || "",
                                            phoneNumber: address.phoneNumber || "",
                                        });
                                        setEditingAddressId(address.id);
                                        setOpenAddressModal(true);
                                    };
                                    openEditModal(addr);
                                }}
                                sx={{
                                    p: 3,
                                    background: '#f8f8f8',
                                    borderRadius: 2,
                                    display: 'flex',
                                    alignItems: 'center',
                                    minHeight: 160,
                                    width: { xs: '80vw', sm: 330, md: '100%' },
                                    minWidth: { xs: '80vw', sm: 300, md: '95%' },
                                    maxWidth: { xs: '100vw', sm: 350, md: 500 }, 
                                    position: 'relative',
                                    mb: 2,
                                    cursor: 'pointer',
                                    '&:hover': {
                                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                                    }
                                }}
                            >
                                <input
                                    type="radio"
                                    checked={selectedAddressId === addr.id}
                                    onChange={(e) => {
                                        e.stopPropagation();
                                        setSelectedAddressId(addr.id);
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                    style={{ marginRight: 16, accentColor: '#CB4422', width: 22, height: 22, cursor: 'pointer' }}
                                />
                                <Box sx={{ flex: 1 }}>
                                    <Typography variant="h6" fontWeight={600} sx={{ mb: 1, fontFamily: 'Poppins' }}>
                                        Saved Address
                                    </Typography>
                                    <Typography sx={{ fontFamily: 'Poppins', mb: 0.5 }}>
                                        {addr.name}
                                    </Typography>
                                    <Typography sx={{ fontFamily: 'Poppins', mb: 0.5 }}>
                                        {addr.houseNo}, {addr.street}
                                    </Typography>
                                    <Typography sx={{ fontFamily: 'Poppins', mb: 0.5 }}>
                                        {addr.city}, {addr.state} - {addr.pincode}
                                    </Typography>
                                    <Typography sx={{ fontFamily: 'Poppins', mb: 0.5 }}>
                                        Phone: {addr.phoneNumber}
                                    </Typography>
                                    <Typography sx={{ fontFamily: 'Poppins' }}>
                                        Email: {addr.email}
                                    </Typography>
                                </Box>
                                <Box sx={{ position: 'absolute', top: 30, right: isSmallScreen ? 20 : 30, zIndex: 3, display: 'flex', gap: 1 }}>
                                    {/* Edit Address */}
                                    <IconButton
                                        size="small"
                                        onClick={() => {
                                            const openEditModal = (address) => {
                                                setAddressForm({
                                                    fullName: address.name || "",
                                                    parentName: address.parentName || "",
                                                    houseNo: address.houseNo || "",
                                                    street: address.street || "",
                                                    village: address.village || "",
                                                    mandal: address.mandal || "",
                                                    district: address.district || "",
                                                    city: address.city || "",
                                                    state: address.state || "",
                                                    country: address.country || "India",
                                                    pincode: address.pincode || "",
                                                    phoneNumber: address.phoneNumber || "",
                                                });
                                                setEditingAddressId(address.id); // <-- Set the editing id
                                                setOpenAddressModal(true);
                                            };
                                            openEditModal(addr);
                                        }}
                                        title="Edit Address"
                                    >
                                        <i className="fas fa-edit" style={{ color: '#1976d2' }} />
                                    </IconButton>
                                    {/* Delete Address */}
                                    <IconButton
                                        size="small" onClick={() => handleDeleteAddress(addr.id)}
                                        title="Delete Address"
                                    >
                                        <i className="fas fa-trash-alt" style={{ color: '#d32f2f' }} />
                                    </IconButton>
                                </Box>
                            </Paper>
                        );
                    })}
                </Box>
                {/* Right: Order Summary */}
                <Paper elevation={0}
                    sx={{
                        flex: 1, width: '100%', maxWidth: { xs: '100%', md: 370 },
                        borderRadius: 3, border: '1px solid #e0e0e0', p: 2.5,
                        background: '#fafafa',
                        alignSelf: { xs: 'stretch', md: 'flex-start' },
                        boxSizing: 'border-box', position: 'relative',
                    }}
                >
                    {/* Add/Edit/Delete Icons */}
                    {/* <Box sx={{ position: 'absolute', top: 12, right: 12, zIndex: 3, display: 'flex', gap: 1 }}>
                    </Box> */}
                    <Typography fontWeight={600} sx={{ fontFamily: 'Poppins', mb: 2 }}> Order Summary </Typography>
                    <Divider sx={{ mb: 2 }} />
                    {products
                        .filter(prod => showMore || !prod.hidden)
                        .slice(0, showMore ? products.length : VISIBLE_COUNT)
                        .map((prod, idx) => (
                            <Box key={prod.cartItemId} sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                <Box component="img" src={prod.image} alt={prod.name}
                                    sx={{ width: 56, height: 56, background: '#e0e0e0', borderRadius: 2, mr: 2, flexShrink: 0, objectFit: 'cover' }} />
                                <Box sx={{ flex: 1 }}>
                                    <Typography sx={{ fontSize: 14, fontFamily: 'Poppins', fontWeight: 500 }}>
                                        {prod.name}
                                    </Typography>
                                    <Typography sx={{ fontSize: 15, fontWeight: 600, mt: 0.5, fontFamily: 'Poppins' }}>
                                        ₹ {(Number(prod.price)).toFixed(2)}
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', ml: 2 }}>
                                    {fromCart ? (
                                        <>
                                            <IconButton size="small" sx={{ border: '1px solid #ddd', borderRadius: 1, p: 0.5 }}
                                                onClick={() => handleDecrement(prod.cartItemId, prod.quantity)}>
                                                <i className="fa-solid fa-minus" style={{ fontSize: 13 }} />
                                            </IconButton>
                                            <Typography sx={{ mx: 1, fontWeight: 500 }}>{prod.quantity}</Typography>
                                            <IconButton size="small" sx={{ border: '1px solid #ddd', borderRadius: 1, p: 0.5 }}
                                                onClick={() => handleIncrement(prod.cartItemId, prod.quantity)}>
                                                <i className="fa-solid fa-plus" style={{ fontSize: 13 }} />
                                            </IconButton>
                                        </>
                                    ) : null}
                                    <IconButton size="small" color="error" sx={{ ml: 1 }}
                                        onClick={() => handleDelete(prod.cartItemId, prod.id, prod.quantity)}>
                                        <i className="fas fa-trash-alt" />
                                    </IconButton>
                                </Box>
                            </Box>
                        ))}
                    {products.length > VISIBLE_COUNT && (
                        !showMore ? (
                            <Typography
                                sx={{
                                    color: '#CB4422',
                                    fontSize: 14,
                                    fontWeight: 500,
                                    textAlign: 'right',
                                    cursor: 'pointer',
                                    mb: 2,
                                }}
                                onClick={() => setShowMore(true)}
                            >
                                Show more
                            </Typography>
                        ) : (
                            <Typography
                                sx={{
                                    color: '#CB4422',
                                    fontSize: 14,
                                    fontWeight: 500,
                                    textAlign: 'right',
                                    cursor: 'pointer',
                                    mb: 2,
                                }}
                                onClick={() => setShowMore(false)}
                            >
                                Show less
                            </Typography>
                        )
                    )}
                    <Divider sx={{ mb: 2 }} />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Typography sx={{ fontFamily: 'Poppins', fontSize: 15 }}>Total Amount</Typography>
                        <Typography sx={{ fontFamily: 'Poppins', fontWeight: 500 }}>₹ {totalAmount}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Typography sx={{ fontFamily: 'Poppins', fontSize: 15 }}>Delivery Charges</Typography>
                        <Typography sx={{ fontFamily: 'Poppins', fontWeight: 500 }}>₹ {deliveryPrice.toFixed(2)}</Typography>
                    </Box>
                    <Divider sx={{ mb: 2 }} />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                        <Typography sx={{ fontFamily: 'Poppins', fontWeight: 600, fontSize: 16 }}>
                            Grand Total
                        </Typography>
                        <Typography sx={{ fontFamily: 'Poppins', fontWeight: 600, fontSize: 16 }}>
                            ₹ {grandTotal.toFixed(2)}
                        </Typography>
                        
                    </Box>
                    <Box 
                        sx={{ display: 'flex', alignItems: 'flex-start', mt: 2, mb: 1 }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Checkbox 
                            checked={termsAccepted}
                            onChange={(e) => {
                                e.stopPropagation();
                                setTermsAccepted(e.target.checked);
                            }}
                            onClick={(e) => e.stopPropagation()}
                            sx={{ 
                                mt: 0.5,
                                '& .MuiSvgIcon-root': { fontSize: 24 },
                                color: '#CB4422',
                                '&.Mui-checked': {
                                    color: '#CB4422',
                                },
                            }}
                        />
                        <Typography 
                            variant="body1" 
                            sx={{ 
                                mt: 1.5, 
                                fontSize: '0.9rem',
                                color: '#555',
                                lineHeight: 1.4
                            }}
                        >
                            I understand that this product is not eligible for exchange or return.
                        </Typography>
                    </Box>
                    <Box sx={{ mt: 2 }}>
                        <Button
                            variant="contained"
                            fullWidth
                            disabled={!termsAccepted}
                            sx={{
                                background: '#CB4422',
                                color: '#fff',
                                fontFamily: 'Poppins',
                                fontWeight: 600,
                                fontSize: 16,
                                borderRadius: 2,
                                py: 1.2,
                                boxShadow: 'none',
                                '&:hover': { background: '#a8341b' },
                                '&.Mui-disabled': {
                                    background: '#f5f5f5',
                                    color: '#a0a0a0',
                                }
                            }}
                            onClick={handlePlaceOrder}
                        >
                            Place Order
                        </Button>
                    </Box>
                </Paper>
            </Box>
            <FeildModel
                open={openAddressModal}
                handleClose={() => setOpenAddressModal(false)}
                fields={fields}
                addressForm={addressForm}
                handleAddressChange={handleAddressChange}
                handleAddressSubmit={handleAddressSubmit}
                addressError={addressError}
                addressSuccess={addressSuccess}
                setAddressForm={setAddressForm}
            />
            {loading && (
                <Box
                    sx={{
                        position: 'fixed',
                        top: 0, left: 0, width: '100vw', height: '100vh',
                        bgcolor: 'rgba(255,255,255,0.7)',
                        zIndex: 9999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <Box>
                        <span className="fa fa-spinner fa-spin" style={{ fontSize: 48, color: '#CB4422' }} />
                        <Typography sx={{ mt: 2, fontWeight: 600, color: '#CB4422', textAlign: 'center' }}>Processing Payment...</Typography>
                    </Box>
                </Box>
            )}
            <ToastContainer />
        </Container>
    );
};

export default Checkout;